export default "__VITE_ASSET__dhzG$SEU__"